module.exports = __webpack_public_path__ + "img/CM-MS-24-Toyota-Established.e13f25f0.jpg";